// extracted by mini-css-extract-plugin
module.exports = {"ProjectsFilter":"ProjectsFilter_ProjectsFilter__2wzMl","ProjectsFilter__select":"ProjectsFilter_ProjectsFilter__select__2d9bE"};